import { render, staticRenderFns } from "./shuibiaozanting.vue?vue&type=template&id=d670c9b8&scoped=true&"
import script from "./shuibiaozanting.vue?vue&type=script&lang=js&"
export * from "./shuibiaozanting.vue?vue&type=script&lang=js&"
import style0 from "./shuibiaozanting.vue?vue&type=style&index=0&id=d670c9b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d670c9b8",
  null
  
)

export default component.exports